import React from 'react';
import { Route, Redirect } from 'react-router-dom'
import { useAuthDataContext } from '../../__providers/AuthProvider';
import Unauthorised from '../error/403';


function ProtectedRoute({ userType, component: Component, ...rest }) {

    const auth = useAuthDataContext();
    const type = auth.user.user_type_id;

    return (
        <Route
            {...rest}
            render={props => {
                if (auth && type) {
                    if (auth.isLogged && userType == type) {
                        if (auth.user.configured == 0) {
                            return <Redirect to="/settings" />
                        }
                        return <Component {...props} />
                    } else {
                        return <Redirect to="/" />

                    }
                } else {
                    return <Unauthorised />
                }
            }}
        />
    )
}

export default ProtectedRoute;
